module.exports = __webpack_public_path__ + "media/icons/car-battery-a6598c04.svg";